export default [
  {
    id: 'd4c5d863-aa27-3a2f-ed9d-80f1bdd63806',
    path: '/host-management',
    name: 'host-management',
    meta: {
      title: '运营商配置',
    },
    children: [
      {
        id: '058a4961-eeb3-0933-8ebf-a00cd78caecf',
        path: 'host-online',
        name: 'host-online',
        component: () => {
          return import('./views/HostOnline')
        },
        meta: {
          title: '在线模块',
        },
      },
      {
        id: 'c05e69d5-9c84-445b-ba97-2996b1692000',
        path: 'menu-register',
        name: 'menu-register',
        component: () => {
          return import('./views/MenuRegister')
        },
        meta: {
          title: '菜单注册',
        },
      },
      {
        id: '9bf88123-1384-4e63-836e-a0b9a1810673',
        path: 'tenant-management',
        name: 'tenant-management',
        component(resolve) {
          require(['./views/TenantManagement'], resolve)
        },
        meta: {
          title: '租户管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: false,
            },
            read: {
              id: 1,
              name: 'updateConnect',
              desc: '修改数据库连接',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: false,
            },
          },
        },
      },
      {
        id: '2f554c04-572e-4850-87a6-af0697703071',
        path: 'tenant-menu',
        name: 'tenant-menu',
        component(resolve) {
          require(['./views/TenantMenu'], resolve)
        },
        meta: {
          title: '租户菜单',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: false,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: false,
            },
          },
        },
      },
      {
        id: '9c50ee94-c993-44be-835e-2d051662f117',
        path: 'user',
        name: 'user',
        component(resolve) {
          require(['./views/User'], resolve)
        },
        meta: {
          title: '用户管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            resetPassword: {
              id: 4,
              name: 'resetPassword',
              desc: '重置密码',
              access: true,
            },
          },
        },
      },
    ],
  },
]
